export default __webpack_public_path__ + "static/media/fabric__stretch.9736d5bb.png";